import fileSys from "../../fileoprators/fileSystem";
import SettingsOprator from "../../settings/settingsoprator";
import { INVALID_1000 } from "../shared/index";
let DEFAULTSET = {
  values: [
    {
      key: "OffsetZ",
      op: "<",
      value: INVALID_1000,
      color: "red",
      abs: true,
      min: 4,
      max: 7,
      priority: 10,
      label: "txtOffsetZTip",
      included: true
    },
    {
      key: "OffsetX",
      op: "<",
      value: INVALID_1000,
      abs: true,
      color: "red",
      min: 6,
      max: 9,
      priority: 9,
      label: "txtOffsetXTip",
      included: true
    },
    {
      key: "OffsetY",
      op: "<",
      value: INVALID_1000,
      abs: true,
      color: "red",
      min: 6,
      max: 9,
      priority: 8,
      label: "txtOffsetYTip",
      included: true
    },
    {
      key: "AreaA",
      op: ">",
      value: INVALID_1000,
      color: "red",
      min: 35,
      max: 56,
      priority: 7,
      label: "txtAreaATip",
      included: true
    },
    {
      key: "AreaU",
      op: ">",
      value: INVALID_1000,
      color: "red",
      min: 35,
      max: 56,
      priority: 6,
      label: "txtAreaUTip",
      included: true
    },
    {
      key: "AreaD",
      op: ">",
      value: INVALID_1000,
      color: "red",
      min: 35,
      max: 56,
      priority: 5,
      label: "txtAreaDTip",
      included: true
    },
    {
      key: "HeightU",
      op: ">",
      value: INVALID_1000,
      color: "red",
      min: 35,
      max: 56,
      priority: 4,
      label: "txtHeightUTip",
      included: true
    },
    {
      key: "HeightD",
      op: ">",
      value: INVALID_1000,
      color: "red",
      min: 35,
      max: 56,
      priority: 3,
      label: "txtHeightDTip",
      included: true
    },
    {
      key: "TearN",
      op: "<",
      value: INVALID_1000,
      color: "red",
      min: 3,
      max: 6,
      priority: 2,
      label: "txtTearNTip",
      included: true
    },
    {
      key: "TearA",
      op: "<",
      value: INVALID_1000,
      color: "red",
      min: 20,
      max: 70,
      priority: 1,
      label: "txtTearATip",
      included: true
    },
    { color: "red", label: "txtScanFailed" }
  ]
};
class QSConfig extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("qs.json"), DEFAULTSET);
    this.QS = this.getSettings();
  }
  getDefaultQS() {
    return DEFAULTSET;
  }
}
export default QSConfig;



// WEBPACK FOOTER //
// ./src/topography/config/qs.js